function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#222",
  fillRule: "evenodd",
  transform: "translate(2 4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.868 3.989l.647.647C3.302 5.394 2.15 6.415 1.114 7.7c-.148.185-.152.428-.011.617C3.046 10.944 6.215 13 9.986 13c.886 0 1.744-.116 2.563-.329l.782.782c-1.059.351-2.181.547-3.347.547-4.19 0-7.71-2.467-9.87-5.62-.156-.227-.152-.52.012-.741 1.141-1.527 2.408-2.743 3.742-3.65zM9.984 2c4.114 0 7.734 2.512 9.901 5.637.153.221.153.506 0 .728-.973 1.423-2.237 2.707-3.71 3.688l-.654-.653c1.341-.82 2.491-1.9 3.376-3.096.137-.185.137-.422 0-.607C16.946 5.093 13.687 3 9.986 3c-.841 0-1.688.113-2.526.339l-.776-.775C7.775 2.188 8.884 2 9.984 2zM6.316 6.438l.785.786C7.035 7.47 7 7.732 7 8c0 1.657 1.343 3 3 3 .268 0 .529-.035.776-.101l.786.785c-.48.203-1.008.316-1.562.316-2.21 0-4-1.79-4-4 0-.554.113-1.082.316-1.562zM10 4c2.21 0 4 1.79 4 4 0 .554-.113 1.082-.316 1.562l-.786-.785C12.965 8.53 13 8.27 13 8c0-1.657-1.343-3-3-3-.269 0-.53.035-.777.102l-.786-.785C8.917 4.113 9.446 4 10 4z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 1,
  x: 0.278,
  y: 7.278,
  rx: 0.5,
  transform: "rotate(45 9.778 7.778)"
}));

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.bdcbebbc.svg";
export { ForwardRef as ReactComponent };